import { useEffect, useRef } from "react";
import {
  faCircleInfo,
  faSort,
  faSortDown,
  faSortUp,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import bootstrap from "bootstrap/dist/js/bootstrap.bundle.min";
import { FIELD_TO_INFO_KEY, INFO_TEXT_MESSAGE } from "./InfoTextMessage";
import "./TableDetails.scss";

const COLUMN_WIDTHS = {
  title: "300px",
  doi: "150px",
  // licenseUrl: "150px",
  // datasetsDli: "150px",
  authors: "240px",
  funders: "250px",
  grantId: "150px",
  // default will be 'auto' if not found here
};

const TableHeadItem = ({
  headingData,
  dataKey,
  handleChange,
  sort,
  customClassName,
}) => {
  const infoIconRef = useRef(null);
  const tooltipRef = useRef(null);

  const infoKey = FIELD_TO_INFO_KEY[headingData?.field];
  const infoText = infoKey ? INFO_TEXT_MESSAGE[infoKey] : "";

  useEffect(() => {
    if (infoIconRef.current && infoText) {
      tooltipRef.current = new bootstrap.Tooltip(infoIconRef.current, {
        placement: "top",
      });
    }
    return () => {
      if (tooltipRef.current) {
        tooltipRef.current.dispose();
      }
    };
  }, [infoText]);

  const handleSort = (order, data) => {
    const field = data.field !== data?.sortKey ? data?.sortKey : data.field;
    handleChange(order, field);
  };

  const informationButtom = <FontAwesomeIcon icon={faCircleInfo} />;

  return headingData?.display ? (
    <th
      key={dataKey}
      className={`align-middle ps-3 py-3 text-nowrap ${
        dataKey === 0 ? "" : customClassName || ""
      }  `}
      style={{
        // Look up the width based on the field name (e.g., "title")
        width: COLUMN_WIDTHS[headingData.field] || "auto",
        minWidth: COLUMN_WIDTHS[headingData.field] || "auto",
      }}
    >
      {headingData.sortable ? (
        <>
          {(sort?.field === headingData?.field ||
            sort?.field === headingData?.sortKey) &&
          sort.order === "desc" ? (
            <div className="d-flex justify-content-start align-items-center">
              <span className="cursor-pointer" onClick={() => handleSort("asc", headingData)}>{headingData.display}</span>
              <FontAwesomeIcon
                className="ms-3 cursor-pointer"
                icon={faSortDown}
                onClick={() => handleSort("asc", headingData)}
              />
              {infoText && (
                <span
                  ref={infoIconRef}
                  className="info-icon"
                  data-bs-toggle="tooltip"
                  title={infoText}
                >
                  {informationButtom}
                </span>
              )}
            </div>
          ) : (sort?.field === headingData?.field ||
              sort?.field === headingData?.sortKey) &&
            sort.order === "asc" ? (
            <div className="d-flex justify-content-start align-items-center">
              <span className="cursor-pointer" onClick={() => handleSort("desc", headingData)}>{headingData.display}</span>
              <FontAwesomeIcon
                className="ms-3 cursor-pointer"
                icon={faSortUp}
                onClick={() => handleSort("desc", headingData)}
              />
              {infoText && (
                <span
                  ref={infoIconRef}
                  className="info-icon"
                  data-bs-toggle="tooltip"
                  title={infoText}
                >
                  {informationButtom}
                </span>
              )}
            </div>
          ) : (
            <div className="d-flex justify-content-start align-items-center">
              <span className="cursor-pointer" onClick={() => handleSort("asc", headingData)}>{headingData.display}</span>
              <FontAwesomeIcon
                className="ms-3 cursor-pointer"
                icon={faSort}
                onClick={() => handleSort("asc", headingData)}
              />
              {infoText && (
                <span
                  ref={infoIconRef}
                  className="info-icon"
                  data-bs-toggle="tooltip"
                  title={infoText}
                >
                  {informationButtom}
                </span>
              )}
            </div>
          )}
        </>
      ) : (
        <div className="d-flex justify-content-start align-items-center">
          {headingData.display}
          {infoText && (
            <span
              ref={infoIconRef}
              className="info-icon"
              data-bs-toggle="tooltip"
              title={infoText}
            >
              {informationButtom}
            </span>
          )}
        </div>
      )}
    </th>
  ) : (
    ""
  );
};

export default TableHeadItem;
